import hasRole from "./permission/hasRole";
import hasPermi from "./permission/hasPermi";
import hasPermissions from "./permission/hasPermissions";

const install = function (Vue) {
  Vue.directive("hasRole", hasRole);
  Vue.directive("hasPermi", hasPermi);
  Vue.directive("hasPermissions", hasPermissions);
};

if (window.Vue) {
  window["hasRole"] = hasRole;
  window["hasPermi"] = hasPermi;
  window["hasPermissions"] = hasPermissions;
  Vue.use(install); // eslint-disable-line
}

export default install;